import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePlanReviewFindingMutationVariables = Types.Exact<{
  input: Types.UpdatePlanReviewFindingInput;
}>;


export type UpdatePlanReviewFindingMutation = { __typename?: 'mutation_root', update_plan_review_finding: { __typename?: 'PlanReviewFindingChangeResult', finding_id: any, review_outcome: string } };


export const UpdatePlanReviewFindingDocument = gql`
    mutation updatePlanReviewFinding($input: UpdatePlanReviewFindingInput!) {
  update_plan_review_finding(input: $input) {
    finding_id
    review_outcome
  }
}
    `;
export type UpdatePlanReviewFindingMutationFn = Apollo.MutationFunction<UpdatePlanReviewFindingMutation, UpdatePlanReviewFindingMutationVariables>;

/**
 * __useUpdatePlanReviewFindingMutation__
 *
 * To run a mutation, you first call `useUpdatePlanReviewFindingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlanReviewFindingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlanReviewFindingMutation, { data, loading, error }] = useUpdatePlanReviewFindingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlanReviewFindingMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlanReviewFindingMutation, UpdatePlanReviewFindingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlanReviewFindingMutation, UpdatePlanReviewFindingMutationVariables>(UpdatePlanReviewFindingDocument, options);
      }
export type UpdatePlanReviewFindingMutationHookResult = ReturnType<typeof useUpdatePlanReviewFindingMutation>;
export type UpdatePlanReviewFindingMutationResult = Apollo.MutationResult<UpdatePlanReviewFindingMutation>;
export type UpdatePlanReviewFindingMutationOptions = Apollo.BaseMutationOptions<UpdatePlanReviewFindingMutation, UpdatePlanReviewFindingMutationVariables>;